module.exports = __webpack_public_path__ + "static/media/eye-outlined.99aa2319.svg";